import AssessmentIcon from "@material-ui/icons/Assessment";
import SchoolIcon from "@material-ui/icons/School";
import BrandingWatermarkIcon from "@material-ui/icons/BrandingWatermark";
import CategoryIcon from "@material-ui/icons/Category";
import ClassIcon from "@material-ui/icons/Class";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import PeopleIcon from "@material-ui/icons/People";
import SportsIcon from "@material-ui/icons/Sports";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import AddAlertIcon from "@material-ui/icons/AddAlert";

import { AppResource } from "../../../types/resource.types";
import { AcademiesCreate, AcademiesEdit, AcademiesList } from "../../Academies";
import { AdsCreate, AdsEdit, AdsList } from "../../Ads";
import { BrandsCreate, BrandsEdit, BrandsList } from "../../Brands";
import { BrandsCategoriesCreate, BrandsCategoriesEdit, BrandsCategoriesList } from "../../BrandsCategories";
import CancellationPolicies from "../../CancellationPolicies";
import { CategoriesCreate, CategoriesEdit, CategoriesList } from "../../Categories";
import Chat from "../../Chat";
import { ClientsList } from "../../Clients";
import { CoachesCreate, CoachesEdit, CoachesList } from "../../Coaches";
import { FaqsCreate, FaqsEdit, FaqsList } from "../../Faqs";
import { GymsCreate, GymsEdit, GymsList } from "../../Gym";
import Settings from "../../Settings/Settings";
import { SportsClubsCreate, SportsClubsEdit, SportsClubsList } from "../../SportsClubs";
import { SportTypesCreate, SportTypesEdit, SportTypesList } from "../../SportTypes";
import Terms from "../../Terms";
import { UserGuideCreate, UserGuideEdit, UserGuideList } from "../../UserGuide";
import { VisitsRequestsShow } from "../../VisitsRequests";
import AdminDashboard from "./Dashboard";
import AdminReviews from "../../AdminReviews";
import CoachReviews from "../../AdminReviews/CoachReviews";
import AcademyReviews from "../../AdminReviews/AcademyReviews";
import SportsClubsReviews from "../../AdminReviews/SportsClubsReviews";
import GymReviews from "../../AdminReviews/GymReviews";
import { EntertainmentsCreate, EntertainmentsEdit, EntertainmentsList } from "../../EntertainmentsVendors";
import EntertainmentReviews from "../../AdminReviews/EntertainmentReviews";
import SportMateEvents from "../../SportMateEvents/List";
import AdminReservations from "../../AdminReservations";
import CourtReservation from "../../AdminReservations/CourtReservation";
import CoachReservations from "../../AdminReservations/CoachReservations";
import StoreOrders from "../../AdminReservations/StoreOrders";
import EntertainmentRequests from "../../AdminReservations/EntertainmentRequests";
import AdventureRequests from "../../AdminReservations/AdventureRequests";
import GymSybscriptions from "../../AdminReservations/GymSybscriptions";
import AcademySubscription from "../../AdminReservations/AcademySubscription";
import { AnnouncementsCreate, AnnouncementsList } from "../../Announcements";

export const adminAccount = {
  resources: [
    <Resource
      name={AppResource.clients}
      list={ClientsList}
      icon={PeopleIcon}
      options={{
        label: "App users",
      }}
    />,
    <Resource
      name={AppResource.sportsClubs}
      list={SportsClubsList}
      edit={SportsClubsEdit}
      create={SportsClubsCreate}
      icon={SportsIcon}
      options={{
        label: "Playground vendors",
      }}
    />,
    <Resource
      name={AppResource.courtsCategories}
      list={CategoriesList}
      edit={CategoriesEdit}
      create={CategoriesCreate}
      icon={CategoryIcon}
      options={{
        label: "Playgrounds category",
      }}
    />,
    <Resource
      name={AppResource.sportTypes}
      list={SportTypesList}
      edit={SportTypesEdit}
      create={SportTypesCreate}
      icon={CategoryIcon}
      options={{
        label: "Sport Types",
      }}
    />,
    <Resource
      name={AppResource.brands}
      list={BrandsList}
      edit={BrandsEdit}
      create={BrandsCreate}
      icon={BrandingWatermarkIcon}
      options={{
        label: "Store vendors",
      }}
    />,
    <Resource
      name={AppResource.brandsCategories}
      list={BrandsCategoriesList}
      edit={BrandsCategoriesEdit}
      create={BrandsCategoriesCreate}
      icon={ClassIcon}
      options={{
        label: "Store category",
      }}
    />,
    <Resource
      name={AppResource.entertainments}
      list={EntertainmentsList}
      edit={EntertainmentsEdit}
      create={EntertainmentsCreate}
      icon={GroupAddIcon}
      options={{
        label: "Entertainment vendors",
      }}
    />,
    <Resource
      name={AppResource.gyms}
      list={GymsList}
      edit={GymsEdit}
      create={GymsCreate}
      icon={MonetizationOnIcon}
      options={{
        label: "Gyms",
      }}
    />,
    <Resource
      name={AppResource.academies}
      list={AcademiesList}
      edit={AcademiesEdit}
      create={AcademiesCreate}
      icon={SchoolIcon}
      options={{
        label: "Academy vendors",
      }}
    />,
    <Resource
      name={AppResource.coaches}
      list={CoachesList}
      edit={CoachesEdit}
      create={CoachesCreate}
      icon={AssessmentIcon}
      options={{
        label: "Sessions",
      }}
    />,
    <Resource
      name={AppResource.ads}
      list={AdsList}
      edit={AdsEdit}
      create={AdsCreate}
      icon={MonetizationOnIcon}
      options={{
        label: "Ads",
      }}
    />,
    <Resource
      name={AppResource.userGuide}
      list={UserGuideList}
      edit={UserGuideEdit}
      create={UserGuideCreate}
      icon={ContactSupportIcon}
      options={{
        label: "User Guide",
      }}
    />,
    <Resource
      name={AppResource.faqs}
      list={FaqsList}
      edit={FaqsEdit}
      create={FaqsCreate}
      icon={LiveHelpIcon}
      options={{
        label: "FAQS",
      }}
    />,
    <Resource
      name={AppResource.sportMateEvents}
      list={SportMateEvents}
      icon={EmojiEventsIcon}
      options={{
        label: "Sport mate events",
      }}
    />,
    <Resource
      name={AppResource.announcements}
      list={AnnouncementsList}
      create={AnnouncementsCreate}
      icon={AddAlertIcon}
      options={{
        label: "Announcements",
      }}
    />,
    <Resource name={AppResource.courts} />,
  ],
  customRoutes: [
    <Route exact path={`/${AppResource.visitsRequests}/:visitRequestId`} component={VisitsRequestsShow} />,
    <Route exact path={`/${AppResource.settings}`} component={Settings} />,
    <Route exact path={`/${AppResource.cancellationPolicies}`} component={CancellationPolicies} />,
    <Route exact path={`/${AppResource.terms}`} component={Terms} />,
    <Route exact path={`/${AppResource.chat}/:roomId`} component={Chat} />,

    // Vendors Reviews
    <Route exact path={`/${AppResource.reviews}`} component={AdminReviews} />,
    <Route exact path={`/${AppResource.gymReviews}`} component={GymReviews} />,
    <Route exact path={`/${AppResource.coachReviews}`} component={CoachReviews} />,
    <Route exact path={`/${AppResource.academyReviews}`} component={AcademyReviews} />,
    <Route exact path={`/${AppResource.sportsClubsReviews}`} component={SportsClubsReviews} />,
    <Route exact path={`/${AppResource.entertainmentReviews}`} component={EntertainmentReviews} />,

    // Vendors Reservations/Orders
    <Route exact path={`/${AppResource.reservations}`} component={AdminReservations} />,
    <Route exact path={`/${AppResource.courtsReservations}`} component={CourtReservation} />,
    <Route exact path={`/${AppResource.sessionsReservations}`} component={CoachReservations} />,
    <Route exact path={`/${AppResource.storeOrders}`} component={StoreOrders} />,
    <Route exact path={`/${AppResource.entertainmentRequests}`} component={EntertainmentRequests} />,
    <Route exact path={`/${AppResource.adventureRequests}`} component={AdventureRequests} />,
    <Route exact path={`/${AppResource.subscribedGyms}`} component={GymSybscriptions} />,
    <Route exact path={`/${AppResource.subscribedAcademies}`} component={AcademySubscription} />,
  ],
  dashboard: AdminDashboard,
};
